var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlansIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F1E7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2305 18.5C20.2305 17.0955 20.2305 16.3933 20.5675 15.8889C20.7134 15.6705 20.9009 15.483 21.1193 15.3371C21.6238 15 22.326 15 23.7305 15C25.135 15 25.8372 15 26.3416 15.3371C26.56 15.483 26.7475 15.6705 26.8934 15.8889C27.2305 16.3933 27.2305 17.0955 27.2305 18.5",
    stroke: "#38056B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7305 26V25.5C33.7305 22.2002 33.7305 20.5502 32.7054 19.5251C31.6802 18.5 30.0303 18.5 26.7305 18.5H20.7305C17.4306 18.5 15.7807 18.5 14.7556 19.5251C13.7305 20.5502 13.7305 22.2002 13.7305 25.5V26C13.7305 29.2998 13.7305 30.9497 14.7556 31.9749C15.7807 33 17.4306 33 20.7305 33H26.7305C30.0303 33 31.6802 33 32.7054 31.9749C33.7305 30.9497 33.7305 29.2998 33.7305 26Z",
    stroke: "#38056B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7305 23C13.7305 23 16.362 27 23.7305 27C31.0989 27 33.7305 23 33.7305 23",
    stroke: "#38056B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8555 23.75H23.7305M23.9805 23.75C23.9805 23.8881 23.8686 24 23.7305 24C23.5924 24 23.4805 23.8881 23.4805 23.75C23.4805 23.6119 23.5924 23.5 23.7305 23.5C23.8686 23.5 23.9805 23.6119 23.9805 23.75Z",
    stroke: "#38056B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansIcon);
export default __webpack_public_path__ + "static/media/plans-icon.bf8ccec2e94666a02d58e64413b50da3.svg";
export { ForwardRef as ReactComponent };